import { render, staticRenderFns } from "./DetallePedido.vue?vue&type=template&id=dc9758a8&"
import script from "./DetallePedido.vue?vue&type=script&lang=js&"
export * from "./DetallePedido.vue?vue&type=script&lang=js&"
import style0 from "./DetallePedido.vue?vue&type=style&index=0&id=dc9758a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports